var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWithHeader", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "btn no-bg",
                on: {
                  click: function($event) {
                    return _vm.setPosSection("choose-product")
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "wrapper" }, [
              _c(
                "div",
                { staticClass: "custom" },
                [
                  _c("BaseNotificationList", {
                    attrs: {
                      title: _vm.$t("message.notifications"),
                      items: _vm.notifications,
                      limitItems: 10
                    },
                    on: { onClickReadAll: _vm.handleClickReadNotifyAll },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function(ref) {
                          var item = ref.itemData
                          return [
                            _vm.NEED_APPROVE_ACCESS_STATUSES.concat(
                              _vm.NEED_APPROVE_ORDERS_STATUSES
                            ).includes(item.code)
                              ? _c("BaseNotificationItemApprove", {
                                  staticClass:
                                    "custom-wrapper-base-notification-approve",
                                  attrs: {
                                    code: item.code,
                                    platform: item.platform,
                                    dateTime: item.created_at,
                                    queueNumber: item.queue_number,
                                    tableNumber: item.table_number,
                                    orderDetail: _vm.getNotifyDetailText(
                                      item.metadata
                                    ),
                                    isRead: item.is_read,
                                    responseStatus: item.metadata.responseStatus
                                  },
                                  on: {
                                    onClickReject: function($event) {
                                      return _vm.handleClickReject(item)
                                    },
                                    onClickApprove: function($event) {
                                      return _vm.handleClickApprove(item)
                                    },
                                    onClickViewOrderNo: function($event) {
                                      return _vm.handleClickViewOrderNo(item)
                                    }
                                  }
                                })
                              : _c("BaseNotificationItemSimple", {
                                  attrs: {
                                    code: item.code,
                                    platform: item.platform,
                                    dateTime: item.created_at,
                                    queueNumber: item.queue_number,
                                    tableNumber: item.table_number,
                                    orderDetail: _vm.getNotifyDetailText(
                                      item.metadata
                                    ),
                                    isRead: item.is_read
                                  },
                                  on: {
                                    onClickRead: function($event) {
                                      return _vm.handleClickReadNotify(item)
                                    },
                                    onClickViewOrderNo: function($event) {
                                      return _vm.handleClickViewOrderNo(item)
                                    }
                                  }
                                })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2a71d66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2a71d66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/NotificationList.vue
// module id = null
// module chunks = 